export const platdrainModel = {
    label: 'Plate bande',
    tableName: 'plat_drain',
    properties: [
        {
            label: 'Site',
            id: 'village',
            isForeignKey: true,
            column_name: 'name',
            table_column: 'siteId',
            type: 'text',
            example: 'Village Nord', // Nom d'un village existant
            required: true
        },
        {
            label: 'Espèce',
            id: 'species',
            isForeignKey: true,
            column_name: 'name',
            table_column: 'specieId',
            type: 'text',
            example: 'Rhizophora mucronata', // Nom de l'espèce
            required: true
        },
        {
            label: 'Date de semis',
            id: 'sowing_date',
            type: 'date',
            example: 'JJ/MM/AAAA', // Format jj/mm/aaaa attendu par votre checkData
            required: true
        },
        {
            label: 'Nombre de pots rebouchés',
            id: 'quantity_rebouche',
            type: 'text',
            example: '50',
            required: true
        },
        {
            label: 'Nombre de pots repiqués',
            id: 'quantity_repique',
            type: 'text',
            example: '150',
            required: true
        },
        {
            label: 'Quantité',
            id: 'quantity',
            type: 'text',
            example: '200',
            required: true
        },
        {
            label: 'Pépiniériste responsable',
            id: 'responsable',
            type: 'text',
            example: 'Jean Dupont',
            required: true
        }
    ]
}
